import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Input } from 'web-ui-components/lib/atoms/forms';
import { batchNameMaxLength } from '../../../config';

const PaymentsBatchToggle = ({
	isBatch,
	handleToggleIsBatch,
	handleBatchNameChanged,
	batchName,
	batchToggleLabel,
	batchToggleLabelSubText,
	batchPaymentNameLabel,
	batchPaymentNameLabelSubText,
	batchToggleMoreText,
	disabledBatchText,
	disabled,
	isEdit,
}) => (
	<div>
		{!isEdit && (
			<div data-cy="batch-checkbox-container">
				<strong>
					<Checkbox
						id="is-batch-checkbox"
						checked={isBatch}
						onChange={() => {
							handleToggleIsBatch(!isBatch);
						}}
						label={batchToggleLabel}
						disabled={disabled}
					/>
				</strong>
				{!disabled && <p> {batchToggleLabelSubText} </p>}
				<p>{disabled ? disabledBatchText : batchToggleMoreText}</p>
			</div>
		)}

		<div className="u-margin-top-2">
			{isBatch && (
				<div>
					<p>
						<strong>{batchPaymentNameLabel}</strong>
					</p>
					<p>{batchPaymentNameLabelSubText}</p>
					<Input
						type="text"
						id="batch-name"
						required=""
						aria-required="true"
						aria-invalid="true"
						value={batchName}
						onChange={handleBatchNameChanged}
						maxLength={batchNameMaxLength}
					/>
				</div>
			)}
		</div>
	</div>
);

PaymentsBatchToggle.propTypes = {
	isBatch: PropTypes.bool.isRequired,
	handleToggleIsBatch: PropTypes.func.isRequired,
	handleBatchNameChanged: PropTypes.func.isRequired,
	batchToggleLabel: PropTypes.string.isRequired,
	batchName: PropTypes.string.isRequired,
	batchPaymentNameLabel: PropTypes.string.isRequired,
	disabled: PropTypes.bool.isRequired,
	batchToggleLabelSubText: PropTypes.string.isRequired,
	batchPaymentNameLabelSubText: PropTypes.string.isRequired,
	batchToggleMoreText: PropTypes.string.isRequired,
	disabledBatchText: PropTypes.string.isRequired,
	isEdit: PropTypes.bool,
};

export default PaymentsBatchToggle;
